import {isMobile} from './viewport';

export default ({ 
    path,
    ...props
}) => (
    <img
        src={`${window.location.origin}/source/${isMobile() ? 'mobile' : 'desktop'}${path}`}
        {...props} />
)